export default class DomainParent {
    hasId() {
        return ((this.id != null) && (this.id != '') && (this.id > 0))
    }
}


// WEBPACK FOOTER //
// ./src/domain/parent/DomainParent.js